import { render, staticRenderFns } from "./TypeTab.vue?vue&type=template&id=2b185f9b&scoped=true&"
import script from "./TypeTab.vue?vue&type=script&lang=js&"
export * from "./TypeTab.vue?vue&type=script&lang=js&"
import style0 from "./TypeTab.vue?vue&type=style&index=0&id=2b185f9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b185f9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
